"use client";

import { PersonSearch } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

import { EntityButtonProps } from "@/types/button";
import { UserBase } from "@/types/user";
import { LookupValidation } from "@/types/validation";

import { useRecaptcha } from "@/context/util/recaptcha";

export default function LookupButton<T extends UserBase>(
  props: EntityButtonProps<T, LookupValidation>
) {
  const { showV2 } = useRecaptcha();

  const hasErrors =
    Object.keys(props.errors).length > 0 ||
    !props.entity?.firstName?.length ||
    !props.entity?.lastName?.length ||
    !props.entity?.birthdate?.length ||
    !props.entity?.zip?.length;

  function getTooltip() {
    if (hasErrors) {
      return `Please complete and validate all fields ${props.tooltipSuffix}`;
    } else if (showV2) {
      return `Please complete the reCAPTCHA ${props.tooltipSuffix}`;
    }
    return `Click ${props.tooltipSuffix}`;
  }

  return (
    <Tooltip title={getTooltip()}>
      <span>
        <Button
          disabled={hasErrors || showV2}
          onClick={() => props.onClick()}
          sx={{
            height: 48,
            padding: "1em 3em",
            width: {
              xs: "100%",
              sm: "auto",
            },
          }}
          startIcon={props.startIcon ?? <PersonSearch />}
          variant="contained"
        >
          {props.label ?? "Lookup"}
        </Button>
      </span>
    </Tooltip>
  );
}
